export default [ 
    //FOR BRANCH USER===============================================================================
    {
        key: "newPr",
        status: "New PR",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "Purchase Request",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "edit",

                buttonLabel: "Edit",
                color: 'warning',
                icon: "icon-edit",
                btnSize: "large",

            },
            {
                buttonType: "action", //if relay it means it will just emit an event to show data. if action it will update db info
                endPoint: "deletePr",
                payLoad: {
                    id: "", //record Id To Update 
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Delete Confirmation",
                rejectReasonMessage: "Why Are you Deleting this PR?",

                buttonLabel: "Delete",
                color: 'danger',
                icon: "icon-trash",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "Are you sure you want to Delete this Purchase Request?",
                successMessage: "This PR has been successfully Deleted",

                sucessEventName: "changeView",
                successEventValue: "list",
            }
        ]

    },
    {
        key: "userApprovedPR",
        status: "Submitted PR Team",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "Approved Purchase Request",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "Submitted HOD",
        status: "Submitted HOD",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "Approved Purchase Request",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "userApprovedByProcurement",
        status: "PO Generated",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "Approved Purchase Request",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
   
    {
        key: "Rejected PR",
        status: "Rejected PR",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "Rejected By HOD Purchase Request",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "Rejected by Procurement",
        status: "Rejected by Procurement",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "Rejected By Procurement Purchase Request",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    }, 
    {
        key: "pendingApprovalByPR",
        status: "Submitted PR Team",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "Pending for Approval",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ] 
    },
     //----------------------------------------------------------------------------------------------
   
    //FOR HOD==========================================================================
    {
        key: "HOD Pending Approval",
        status: "Submitted HOD",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "HOD Pending Approval", 
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        key: "hodRejectedByhod",
        status: "Rejected by HOD",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "Rejected By HOD",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ] 
    },
    {
        key: "hodRejectedByPR",
        status: "Rejected by Procurement",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "Rejected By Procurement",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ] 
    },
    {
        key: "submittedToPr",
        status: "Submitted PR Team",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "PO Generated",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ] 
    },
     //----------------------------------------------------------------------------------------------
   
    //FOR PROCUREMENT TEAM==========================================================================
    {
        key: "PO Generated",
        status: "PO Generated",
        label: "Main Information",
        showInvoicePreview: true,   //this is unique to PR data
        invoiceTitle: "PO Generated",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ] 
    },
]